<div class="subheader-approve-reject-buttons-container">
	<div
		class="btn-group btn-group-sm cv-btn-group approve-btn"
		role="group"
		*ngIf="orderDetail.stateEnum !== orderStatus.REJECTED"
	>
		<button
			type="button"
			[disabled]="disabledApprove"
			[ngClass]="{
					'btn btn-sm cv-btn-light': true,
					'no-actions': orderDetail.stateEnum === orderStatus.APPROVED || orderDetail.stateEnum === orderStatus.CANCELLED,
					disabled: disabledApprove
				}"
			(click)="approveOrder()"
		>
			<i
				[ngClass]="{
						'fa fa-thumbs-up': true,
						'icon-approved': orderDetail.stateEnum === orderStatus.APPROVED
					}"
			></i>
			<span>{{ approveBtn }}</span>
		</button>
	</div>
	<div
		class="btn-group btn-group-sm cv-btn-group"
		role="group"
		*ngIf="orderDetail.stateEnum !== orderStatus.APPROVED"
	>
		<button
			type="button"
			#rejectBoxBtn
			[disabled]="disabledReject"
			[ngClass]="{
					'btn btn-sm cv-btn-light': true,
					'no-actions': orderDetail.stateEnum === orderStatus.REJECTED || orderDetail.stateEnum === orderStatus.CANCELLED,
					disabled: disabledReject
				}"
			(click)="toggleRejectionBox()"
		>
			<i
				*ngIf="!isRecallingBtn"
				class="fas fa-thumbs-down"
				[ngClass]="{
						'icon-reject': orderDetail.stateEnum === orderStatus.REJECTED
					}"
			></i>
			<span *ngIf="isRecallingBtn" class="spinner-border spinner-border-sm me-1"></span>
			<span>{{ rejectBtn }}</span>
		</button>
	</div>
</div>


<div #rejectBox class="cv-rejection-box">
	<label class="cv-rejection-box__title">Note</label>
	<textarea
		#rejectionNote
		class="cv-rejection-box__placeholder"
		placeholder="Add your notes here..."
	></textarea>
	<label class="cv-rejection-box__title">Summary</label>
	<div
		[innerHTML]="summary | safeHtml"
		class="cv-rejection-box-summary cv-rejection-box__placeholder"
	></div>
	<div>
		<a
			href="javascript:void(0)"
			class="copyto-clipboard"
			ngxClipboard
			[cbContent]="summary | stripHTMLTags"
		>
			Copy to Clipboard
		</a>
		<button
			type="button"
			class="btn btn-danger"
			(click)="rejectOrder(rejectionNote.value)"
			[disabled]="disabledReject"
		>
			Reject
		</button>

		<button type="button" class="btn btn-light" (click)="toggleRejectionBox()">
			Cancel
		</button>
	</div>
</div>
